"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _react = require('react');var _jsxruntime = require('react/jsx-runtime');var a=_styled2.default.div`
  position: relative;
  height: ${e=>e.theme.measurements.spacing(2)};
`,n=_styled2.default.div`
  left: 0;
  right: 0;
  display: block;
  z-index: 1;
  height: ${e=>e.theme.measurements.spacing(2)};
  border-radius: ${e=>e.theme.measurements.shape(7.5)};
  background: ${e=>e.theme.palette.WHITE};
  opacity: 30%;
`,m=_styled2.default.call(void 0, a)`
  height: ${e=>e.theme.measurements.spacing(2)};
  width: ${e=>e.$width};
  background: ${e=>e.theme.palette.WHITE};
  position: absolute;
  border-radius: ${e=>e.theme.measurements.shape(7.5)};
  left: 0;
  top: 0;
  z-index: 2;
`;function h(e){let{progress:r}=e,o=_react.useMemo.call(void 0, ()=>`${r}%`,[r]);return _jsxruntime.jsxs.call(void 0, a,{children:[_jsxruntime.jsx.call(void 0, n,{}),_jsxruntime.jsx.call(void 0, m,{$width:o})]})}var c=h;exports.a = c;
